import React from 'react';
import propTypes from 'prop-types';
import Form from 'react-forms-system';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextInputControl from '@/components/TextInputControl';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { required } from '@/core/validators';
import Alert from '@material-ui/lab/Alert';

import logoBlue from '@/assets/burst-logo-blue.png';

import './Login.styles.scss';

const Login = ({ controller }) => (
  <div className="Login">
    <div className="overlay" />
    <title>Login</title>
    <Card className="form-container">
      <CardContent>
        <div className="logo-container">
          <img src={logoBlue} className="logo" alt="Burst Fitness" />
        </div>
        <Form onSubmit={controller.handleLoginPress} className="form">
          <div className="form-control">
            <Form.Control
              name="email"
              component={TextInputControl}
              label="Email"
              type="email"
              variant="outlined"
              errorMessages={{ required: 'Required' }}
              validators={{ required }}
            />
          </div>

          <div className="form-control">
            <Form.Control
              name="password"
              component={TextInputControl}
              label="Password"
              type="password"
              autoComplete="current-password"
              variant="outlined"
              errorMessages={{ required: 'Required' }}
              validators={{ required }}
            />
          </div>

          <div className="form-control actions">
            <Button variant="contained" color="primary" type="submit">
              Log In
            </Button>
          </div>
        </Form>

        <div className="forgot-password-container">
          <Typography align="center">
            <Button
              variant="text"
              color="secondary"
              onClick={controller.handleForgotPasswordPress}
            >
              Forgot your password?
            </Button>
          </Typography>
        </div>

        <div className="form-control actions">
          <Button
            variant="outlined"
            color="secondary"
            onClick={controller.handleCreateAccountPress}
          >
            Create Account
          </Button>
        </div>

        {controller.errorMessage && (
          <Alert severity="error" variant="filled">
            {controller.errorMessage}
          </Alert>
        )}
      </CardContent>
    </Card>
  </div>
);

Login.propTypes = {
  controller: propTypes.shape({
    email: propTypes.string.isRequired,
    password: propTypes.string.isRequired,
    errorMessage: propTypes.string,
    handleLoginPress: propTypes.func.isRequired,
    handleForgotPasswordPress: propTypes.func.isRequired,
    handleCreateAccountPress: propTypes.func.isRequired,
    handleLoginChange: propTypes.func.isRequired,
  }).isRequired,
};

export default Login;
